import { connect } from 'react-redux'
import { setTiledMenuIsLoaded } from 'redux/actions'
import LegislationTiledMenu from 'components/tiled-menu/LegislationTiledMenu'

const mapStateToProps = state => ({
  folders: state.legislation.folders
})

const mapDispatchToProps = dispatch => ({
  setTiledMenuIsLoaded: isLoaded => dispatch(setTiledMenuIsLoaded(isLoaded))
})

export default connect(mapStateToProps, mapDispatchToProps)(LegislationTiledMenu)
